module.exports = __webpack_public_path__ + "static/img/Western-Bulldogs.1184180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Western-Bulldogs.jpg
// module id = kofC
// module chunks = 1